import { render, staticRenderFns } from "./AddRichTextDocModal.vue?vue&type=template&id=41cca3a6&scoped=true&"
import script from "./AddRichTextDocModal.vue?vue&type=script&lang=ts&"
export * from "./AddRichTextDocModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cca3a6",
  null
  
)

export default component.exports